import { Helmet } from 'react-helmet-async';
import { BASE_URL } from '../data/routes';

interface PageSEOProps {
  title: string;
  description: string;
  path: string;
  type?: 'website' | 'article';
  schema?: Record<string, unknown> | Record<string, unknown>[];
}

export function PageSEO({ title, description, path, type = 'website', schema }: PageSEOProps) {
  const url = path === '/' ? `${BASE_URL}/` : `${BASE_URL}${path}`;
  const schemas = Array.isArray(schema) ? schema : schema ? [schema] : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${BASE_URL}/og-image.png`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${BASE_URL}/og-image.png`} />
      {schemas.map((item, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}

export function webApplicationSchema(name: string, description: string, path: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name,
    url: `${BASE_URL}${path}`,
    applicationCategory: 'UtilitiesApplication',
    operatingSystem: 'Web',
    description,
    publisher: {
      '@type': 'Organization',
      name: 'Power.ng',
      url: `${BASE_URL}/`,
    },
  };
}
